import React, {useState,useEffect} from 'react'
import axios from '../../../../api/axios';
import { useAuth } from '../../../../ContextApp/AuthContext';
import { useNavigate } from 'react-router-dom';

function Add(){
const navigate=useNavigate()
const [sections,setSections]=useState([]);
const [sectionOrganisee,setSectionOrganisee]=useState("")
const [nombreClasses,setNombreClasses]=useState("")
const [message,setMessage]=useState("")
const sectionselected=sections.find(section=>section.id===Number(sectionOrganisee));

const {user}=useAuth();
    useEffect(()=>{
        handleSection();
    },[])
    const csrf=async()=>await axios.get('/sanctum/csrf-cookie');

    const handleSection=async()=>{
        await csrf();
        await axios.get('api/Section').then((res)=>{
            setSections(res.data.items);
            console.log(res.data.items);
        }

        ).catch((err)=>{})
    }
    const handleSubmit=async(e)=>{
        e.preventDefault();
        await csrf();
        await axios.post('api/Sectionorganisee',{
            section_id:Number(sectionOrganisee),
            nombre_classe:Number(nombreClasses),
            idecole:user?.ecole?.id,
            section_nom:sectionselected?.nom
        }).then((res)=>{
            setMessage(res.data.message);
            setSectionOrganisee("")
            setNombreClasses("")
        }).catch((err)=>{})
    }
    return(
        <>
    <div className="container py-5">
        <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
                {/* Carte principale */}
                <div className="card shadow-lg border-0 rounded-4">
                    
                    {/* En-tête colorée de la carte */}
                    <div className="card-header bg-primary bg-gradient text-white text-center py-4 border-0 rounded-top-4">
                        <h2 className="h4 fw-bold mb-0">Nouvelle Section Organisée</h2>
                        <p className="small mb-0 opacity-75">Configurez les paramètres de votre nouvelle section</p>
                    </div>

                    <div className="card-body p-4 p-md-5">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            
                            {/* Sélecteur de Section */}
                            <div className="mb-4">
                                <label htmlFor="section" className="form-label fw-semibold text-secondary">
                                    <i className="bi bi-grid-3x3-gap me-2"></i>Choisir la section
                                </label>
                                <select 
                                    name="section" 
                                    id="section" 
                                    value={sectionOrganisee} 
                                    onChange={(e) => setSectionOrganisee(e.target.value)} 
                                    className="form-select form-select-lg border-2 focus-ring focus-ring-primary" 
                                    required
                                >
                                    <option value="" disabled>Sélectionnez une option...</option>
                                    {sections?.map(section => (
                                        <option key={section.id} value={section.id}>{section.nom}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Input Nombre de classes */}
                            <div className="mb-4">
                                <label htmlFor="nombre" className="form-label fw-semibold text-secondary">
                                    <i className="bi bi-layers me-2"></i>Nombre de classes
                                </label>
                                <input 
                                    type="number" 
                                    name="nombre" 
                                    id="nombre" 
                                    className="form-control form-control-lg border-2" 
                                    placeholder="Ex: 5"
                                    value={nombreClasses} 
                                    onChange={(e) => setNombreClasses(e.target.value)} 
                                    min="1"
                                    required 
                                />
                                <div className="form-text">Indiquez le total de classes prévues pour cette section.</div>
                            </div>

                            {/* Message de succès stylisé */}
                            {message && (
                                <div className="alert alert-subtle-success border-0 shadow-sm d-flex align-items-center mb-4" role="alert">
                                    <i className="bi bi-check-circle-fill me-2"></i>
                                    <div>{message}</div>
                                </div>
                            )}

                            {/* Boutons d'action */}
                            <div className="d-grid gap-2 pt-2">
                                <button className="btn btn-primary btn-lg fw-bold shadow-sm rounded-pill" type="submit">
                                    <i className="bi bi-plus-circle me-2"></i>Confirmer l'ajout
                                </button>
                                <button 
                                    type="button" 
                                    className="btn btn-link text-decoration-none text-muted btn-sm"
                                    onClick={() => navigate('/Sections')}
                                >
                                    Annuler et retourner
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                {/* Petite aide en bas de page */}
                <p className="text-center text-muted mt-4 small">
                    Besoin d'aide ? Consultez le <a href="#" className="text-primary">guide de configuration</a>.
                </p>
            </div>
        </div>
    </div>
</>

    )
}
export default Add